function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import { AppContext } from 'context';
import GoToArrow from 'components/GoToArrow';
import Link from 'components/Link';
import intlShape from 'shapes/intlShape';
import App from 'modules/App';
import * as actions from '../../../actions';
import * as constants from '../../../constants';
import * as selectors from '../../../selectors';
import * as shapes from '../../../shapes';
import messages from '../../../messages';
import styles from './AppBox.pcss';
var _React_PureComponent;
class AppBox extends (_React_PureComponent = React.PureComponent) {
    onClick(evt) {
        if (this.props.to) {
            return;
        }
        evt.preventDefault();
        this.props.onGoToApp();
    }
    get isScopeBusiness() {
        const { scope } = this.props.loadedIdentity;
        return constants.BUSINESS_SCOPES.findIndex((s)=>s === scope) >= 0;
    }
    renderImage() {
        const { app } = this.props;
        return /*#__PURE__*/ _jsx("figure", {
            className: styles.app__logo,
            children: /*#__PURE__*/ _jsx("img", {
                src: `/aid/assets/apps/${app.image}`,
                alt: app.name
            })
        });
    }
    renderHeader() {
        return /*#__PURE__*/ _jsx("h4", {
            className: "text--large",
            children: this.props.app.name
        });
    }
    renderInfo() {
        let message = messages.appsDescriptions[this.props.app.key];
        if (!message) {
            return null;
        }
        if (!message.id) {
            if (this.isScopeBusiness && message.business) message = message.business;
            else if (message.private) message = message.private;
        }
        return /*#__PURE__*/ _jsx("p", {
            className: "text--normal text--base-color text-lh--14 mt-2 mb-1",
            children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, message))
        });
    }
    renderScopes() {
        const { app } = this.props;
        const lastIdx = app.scopes.length - 1;
        return app.scopes.map((scopeName, idx)=>` ${this.props.intl.formatMessage(messages.scopes[scopeName])}${idx === lastIdx ? '.' : ','}`);
    }
    renderAvailableFor() {
        return /*#__PURE__*/ _jsxs("p", {
            className: "linkTile__info",
            children: [
                /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.infos.availableFor)),
                ":",
                this.renderScopes()
            ]
        });
    }
    renderContent() {
        return /*#__PURE__*/ _jsxs("div", {
            children: [
                this.renderHeader(),
                this.renderInfo(),
                this.renderAvailableFor()
            ]
        });
    }
    renderArrow() {
        return /*#__PURE__*/ _jsx("div", {
            className: "col-auto",
            children: /*#__PURE__*/ _jsx(GoToArrow, {})
        });
    }
    render() {
        return /*#__PURE__*/ _jsx(Link, {
            className: "linkTile linkTile--border",
            to: this.props.to,
            onClick: (evt)=>this.onClick(evt),
            children: /*#__PURE__*/ _jsxs("div", {
                className: "row align-items-center",
                "data-testid": "app-catalog-link",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-12 col-sm-auto",
                        children: this.renderImage()
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "col",
                        children: this.renderContent()
                    }),
                    this.renderArrow()
                ]
            })
        });
    }
}
_define_property(AppBox, "contextType", AppContext);
_define_property(AppBox, "propTypes", {
    // Explicit props
    app: PropTypes.shape({
        key: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        image: PropTypes.string.isRequired,
        scopes: PropTypes.arrayOf(shapes.scopeName).isRequired
    }),
    to: PropTypes.string,
    // Implicit props
    loadedIdentity: shapes.identity,
    localizationResources: PropTypes.object,
    intl: intlShape,
    // Implicit actions
    onGoToApp: PropTypes.func
});
_define_property(AppBox, "defaultProps", {
    to: ''
});
const mapStateToProps = (state)=>({
        loadedIdentity: selectors.loadedIdentity(state),
        localizationResources: App.selectors.localizationResources(state)
    });
const mapDispatchToProps = (dispatch, props)=>({
        onGoToApp: ()=>dispatch(actions.goToApp(props.app.key))
    });
const ConnectedAppBox = connect(mapStateToProps, mapDispatchToProps)(injectIntl(AppBox));
export default withStyles(styles)(ConnectedAppBox);
